import { QuestionProps } from '@de/components/Step/Step';
import SingleChoicePillsQuestion from './SingleChoicePillsQuestion';
import SingleChoiceTilesQuestion from './SingleChoiceTilesQuestion';

type SingleQuestionVariant = 'PILL' | 'TILE';

const SingleQuestionMap: Record<
  SingleQuestionVariant,
  React.ComponentType<QuestionProps>
> = {
  TILE: SingleChoiceTilesQuestion,
  PILL: SingleChoicePillsQuestion,
};

function SingleChoiceQuestion(props: QuestionProps) {
  if (!props.variant) {
    return <SingleChoicePillsQuestion {...props} />;
  }

  const variant = props.variant as SingleQuestionVariant;
  const Component = SingleQuestionMap[variant] || SingleChoicePillsQuestion;

  return <Component {...props} />;
}

export default SingleChoiceQuestion;
